import DashboardLayout from 'src/pages/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from 'src/pages/GeneralViews/NotFoundPage.vue'
// Dashboard pages
import Overview from 'src/pages/Dashboard/Dashboard/Overview.vue'
import Stats from 'src/pages/Dashboard/Dashboard/Stats.vue'
import UserList from 'src/pages/Dashboard/UserList.vue'
import UserGroupList from 'src/pages/Dashboard/UserGroupList.vue'

import ItemList from 'src/pages/Dashboard/ItemList.vue'
import GoodList from 'src/pages/Dashboard/GoodList.vue'

import CategoryList from 'src/pages/Dashboard/CategoryList.vue'
import SaleGroupList from 'src/pages/Dashboard/SaleGroupList.vue'
import SalePageList from 'src/pages/Dashboard/Pages/SalePageList.vue'
import OrderList from 'src/pages/Dashboard/Pages/OrderList.vue'
import BannerList from 'src/pages/Dashboard/Pages/BannerList.vue'
import CurrencyList from 'src/pages/Dashboard/Pages/CurrencyList.vue'
import storePage from 'src/pages/Dashboard/Pages/Store.vue'
import BranchList from 'src/pages/Dashboard/Pages/BranchList.vue'
import Languages from 'src/pages/Dashboard/Languages.vue'
import AddPurchaseList from 'src/pages/Dashboard/Pages/AddPurchaseList.vue'

import Login from 'src/pages/Dashboard/Pages/Login.vue'



let loginPage = {
  path: '/login',
  name: 'Login',
  component: Login
}

const routes = [
  {
    path: '/',
    // redirect: '/admin/overview'
    redirect: '/login'
  },
  loginPage,
  {
    path: '/admin',
    component: DashboardLayout,
    // redirect: '/admin/overview',
    redirect: '/admin/items',
    children: [
      // {
      //   path: 'overview',
      //   name: 'Overview',
      //   meta: { text: "Overview" },
      //   component: Overview
      // },
      {
        path: 'stats',
        name: 'Stats',
        component: Stats
      },
      {
        path: 'user_groups',
        name: 'user_groups',
        meta: { text: "使用者群組" },
        component: UserGroupList
      },
      {
        path: 'users',
        name: 'users',
        meta: { text: "使用者" },
        component: UserList
      },
      
      {
        path: 'items',
        name: 'items',
        meta: { text: "料號設定" },
        component: ItemList
      },
      {
        path: 'goods',
        name: 'goods',
        meta: { text: "貨號設定" },
        component: GoodList
      },
      {
        path: 'categories',
        name: 'categories',
        meta: { text: "分類設定" },
        component: CategoryList
      },
      {
        path: 'sale_groups',
        name: 'sale_groups',
        meta: { text: "銷售頁群組" },
        component: SaleGroupList
      },
      {
        path: 'sale_groups/:id/sale_pages',
        name: 'sale_pages',
        meta: { text: "銷售頁群組" },
        component: SalePageList,
        props: true
      },
      {
        path: 'orders',
        name: 'orders',
        meta: { text: "訂單列表" },
        component: OrderList
      },
      {
        path: 'sliders',
        name: 'sliders',
        meta: { text: "sliders" },
        component: BannerList
      },
      {
        path: 'currencies',
        name: 'currencies',
        meta: { text: "幣別" },
        component: CurrencyList
      },
      {
        path: 'store',
        name: 'store',
        meta: { text: "商店設定" },
        component: storePage
      },
      {
        path: 'branches',
        name: 'branches',
        meta: { text: "分店設定" },
        component: BranchList
      },
      {
        path: 'languages',
        name: 'languages',
        meta: { text: "語言" },
        component: Languages
      },
      {
        path: 'addpurchases',
        name: 'addpurchases',
        meta: { text: "加購商品" },
        component: AddPurchaseList
      },
      
    ]
  },
  {path: '*', component: NotFound}
]

export default routes
